// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconNewWindow.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconNewWindow = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M4 13H15C15.552 13 16 12.553 16 12V1C16 0.448 15.552 0 15 0H4C3.447 0 3 0.448 3 1V12C3 12.553 3.447 13 4 13ZM14 11H5V2H14V11ZM1 16H12C12.552 16 13 15.553 13 15V14H2V3H1C0.447001 3 0 3.448 0 4V15C0 15.553 0.447001 16 1 16Z" />
  </BaseIcon>
);

export default IconNewWindow;
